const spacing = {
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  5: '24px',
  6: '32px',
  7: '40px',
  8: '48px'
};
const layout = {
  1: '16px',
  2: '24px',
  3: '32px',
  4: '48px',
  5: '64px',
  6: '96px',
  7: '128px',
  8: '192px',
  9: '256px'
};

export { layout, spacing };
//# sourceMappingURL=Spacing.js.map
